<section class="testimonial-partner">
  <div class="box">
    <div class="partner-topic">
      <ng-container *ngFor="let score of ServiceList">
        <span class="partner-topic__heading color-gray">
          {{ 'BECOME_OUR_PARTNER.TESTIMONIAL_PARTNER.HEADING_LAYOUT_1' | translate }} {{ score.data.totalPartners.iv }}
          {{ 'BECOME_OUR_PARTNER.TESTIMONIAL_PARTNER.HEADING_LAYOUT_2' | translate }}
        </span>

        <div class="partner-topic__link">
          <a
            id="becomePartnerFormLink"
            href="https://form.flowaccount.com/request-become-partner"
            target="_blank"
            rel="noopener noreferrer"
            class="link-app-line read-more"
            aria-label="read-more"
          >
            <span>{{ 'BECOME_OUR_PARTNER.SECTION_TESTIMONIAL.LINK' | translate }}</span
            ><i class="fas fa-angle-right right"></i>
          </a>
        </div>
      </ng-container>
    </div>
    <div class="swiper-container-main">
      <swiper-container class="swiper" appSwiper [config]="config" init="false">
        <ng-container *ngFor="let item of testimonialList">
          <swiper-slide class="swiper-slide">
            <div
              class="bg-hover"
              *ngIf="item.data.CompanyLink.iv"
              (click)="linkToPartnerWebsite($event, item.data.CompanyLink.iv)"
            >
              <div class="icon-text">
                <svg class="square-arrow-up-right" height="1em" viewBox="0 0 448 512">
                  <style>
                    svg {
                      fill: #2898cb;
                    }
                  </style>
                  <path
                    d="M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
                  />
                </svg>
                <span>{{ 'BECOME_OUR_PARTNER.TESTIMONIAL_PARTNER.WEBSITE_LINK' | translate }}</span>
              </div>
            </div>

            <div class="partner-testimonial-card">
              <div class="card-top card-top--desktop">
                {{ item.data.SpeakerQuote.iv }}
              </div>

              <div class="card-bottom">
                <div class="speaker">
                  <div class="speaker__image-cover">
                    <picture>
                      <source [srcset]="item.data.imageWebP.iv" type="image/webp" />
                      <img
                        [src]="item.data.Image.iv"
                        width="100%"
                        loading="lazy"
                        class="card__image"
                        alt="{{ item.data.speakerName.iv }}"
                        title="{{ item.data.speakerName.iv }}"
                      />
                    </picture>
                  </div>
                  <div class="speaker__detail">
                    <div class="speaker__detail-name"> {{ item.data.speakerName.iv }}</div>

                    <div class="speaker__detail-position">{{ item.data.speakerJob.iv }}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </ng-container>
      </swiper-container>
      <div class="swiper-button-prev">
        <i class="cursor fas fa-arrow-left"></i>
      </div>
      <div class="swiper-button-next">
        <i class="cursor fas fa-arrow-right"></i>
      </div>
    </div>
  </div>
</section>
